import { apiClient } from '~/api';
import type { BlogTagPageData } from '~/types/pages/blogTagPageData';

export default async function getBlogTagPage(slug: string, locale: string) {
  return apiClient<BlogTagPageData>('/pages/blog-article-tag-page', {
    cacheKey: getApiRequestCacheKey('blogTagPage', {
      slug,
      locale,
    }),
    params: {
      locale,
      slug,
    },
  });
}
